import { Link } from "react-router-dom";
const activityCards = [
  {
    title: "YOGA",
    subtitle: "(Yoga) \u2013 Weisheit, die K\xF6rper, Geist und Seele in Einklang bringt",
    description: "Yoga ist ein unverzichtbarer Bestandteil der ayurvedischen Lehren und eines gesunden Lebensstils. Durch bewusste Atmung, koordinierte Bewegungen und entspannende Praktiken k\xF6nnen wir wieder mehr Beweglichkeit, innere Ruhe und Klarheit gewinnen. So \xF6ffnen sich neue M\xF6glichkeiten f\xFCr ein bewussteres, erf\xFCllteres Selbst.",
    ctaLabel: "Mehr \xFCber Yoga erfahren",
    href: "/activities",
    image: "/images/Hiru/yoga_01-1348x598.webp",
    alt: "Yoga-Session im Resort"
  },
  {
    title: "Qi Gong",
    subtitle: "\u2013 Lebensenergie n\xE4hren",
    description: "Qi Gong ist eine alte chinesische Tradition, die K\xF6rper und Geist von innen heraus st\xE4rkt. Inmitten der reichen Natur Sri Lankas hilft diese Praxis, zur Ruhe zu kommen und die eigene Lebensenergie wieder frei flie\xDFen zu lassen.",
    ctaLabel: "Mehr \xFCber Qi Gong erfahren",
    href: "/activities",
    image: "/images/Hiru/tai-chi.webp",
    alt: "Qi Gong in der Natur"
  },
  {
    title: "Musiktherapie",
    subtitle: "(Musiktherapie) \u2013 Kl\xE4nge, die die Seele ber\xFChren",
    description: "Auf unserem Resort sch\xE4tzen wir die tiefe heilende Kraft von Musik. Die sanften Klangwellen traditioneller Instrumente sprechen unsere Sinne an und f\xFChren K\xF6rper und Geist, die durch Ayurveda in Balance gebracht wurden, in eine noch tiefere Ruhe.",
    ctaLabel: "Mehr \xFCber Musiktherapie erfahren",
    href: "/activities",
    image: "/images/Hiru/sidharspieler-1348x598.webp",
    alt: "Musiktherapie-Illustration"
  }
];
const AboutActivities = () => {
  return <section
    id="about-activities"
    className="relative isolate overflow-hidden bg-white py-16 sm:py-20 lg:py-28"
  >

            <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="mx-auto max-w-3xl text-center">
                    <span className="inline-flex items-center gap-2 rounded-full border border-amber-200 bg-white/80 px-4 py-2 font-mulish text-xs font-semibold uppercase tracking-[0.14em] text-amber-800 shadow-sm backdrop-blur md:text-sm">
                        Resort-Aktivitäten
                    </span>

                    <h2 className="mt-5 font-serif text-3xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-4xl lg:text-5xl">
                        Aktivitäten auf dem Resort
                    </h2>

                    <p className="mt-4 font-serif text-2xl font-semibold tracking-[0.04em] text-[#1f4d3c] sm:text-[2rem]">
                        Eine besondere Zeit, die innere Schönheit und Stille wieder erweckt
                    </p>
                </div>

                <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-3 lg:gap-7">
                    {activityCards.map((card) => <article
    key={card.title}
    className="group overflow-hidden rounded-[32px] border border-amber-100 bg-white shadow-[0_30px_80px_rgba(15,23,42,0.12)] transition-transform duration-300 hover:-translate-y-1"
  >
                            <div className="relative h-[320px] overflow-hidden sm:h-[360px]">
                                <img
    src={card.image}
    alt={card.alt}
    className="object-cover object-center transition-transform duration-500 group-hover:scale-105" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} loading="lazy" />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/18 to-transparent" />

                                <div className="absolute inset-x-0 bottom-0 p-5 sm:p-6">
                                    <p className="font-mulish text-xs font-semibold uppercase tracking-[0.22em] text-white/80">
                                        Wellness-Programm
                                    </p>
                                    <h3 className="mt-3 font-serif text-3xl font-semibold tracking-tight text-white sm:text-[2.15rem]">
                                        {card.title}
                                    </h3>
                                    <p className="mt-2 max-w-md font-mulish text-sm leading-7 text-white/88 sm:text-base">
                                        {card.subtitle}
                                    </p>
                                </div>
                            </div>

                            <div className="space-y-5 p-6 sm:p-7">
                                <p className="font-mulish text-base leading-relaxed text-gray-700 lg:text-lg">
                                    {card.description}
                                </p>

                                <Link
    to={card.href}
    className="inline-flex items-center justify-center rounded-full bg-[#F28600] px-6 py-3 font-mulish text-sm font-semibold text-white shadow-lg shadow-[#f28600]/25 transition hover:bg-[#d67000]"
  >
                                    {card.ctaLabel}
                                </Link>
                            </div>
                        </article>)}
                </div>

                <div className="mt-10 flex justify-center">
                    <Link
    to="/activities"
    className="inline-flex items-center justify-center rounded-full bg-[#F28600] px-8 py-3.5 font-mulish text-sm font-semibold text-white shadow-lg shadow-[#f28600]/25 transition hover:bg-[#d67000]"
  >
                        Alle Aktivitäten ansehen
                    </Link>
                </div>
            </div>
        </section>;
};
export default AboutActivities;
